import React from 'react'
import './resultContainer.css'
import { useSelector } from 'react-redux'
import convertHxBxT from '../../util/convertHxBxT'

/* var valueArray = [
    jsonData.werkid,
    jsonData.bildtitel_beschreibung,
    kuenstlerValue,
    besitzerValue,
    jsonData.datierung,
    jsonData.technik,
    HxB_oR,
    jsonData.ausstellungen
    ]; */

function ResultContainer({
	data,
	selectedArtwork,
	setSelectedArtwork,
	findArtistFullName,
	findOwnerFullName,
}) {
	const pex = useSelector((state) => state.user.value.pex)
	const read_owner = pex.read_owner || pex.read_owner_names
	const read_artist = pex.read_artist || pex.read_artist_names
	const noPermissionText = 'Keine Berechtigung'

	const loadedIds = useSelector((state) => state.entityIds['artwork']) ?? []
	const loadedArtistIds =
		useSelector((state) => state.entityIds['artist']) ?? []
	const loadedOwnerIds = useSelector((state) => state.entityIds['owner']) ?? []

	return (
		<div id='resultContainer'>
			<table id='resultTable'>
				<tbody>
					<tr className='dataHeader'>
						<td id='header_werkid'>
							<strong>
								laufende
								<br />
								Werke&#8209;Nr.
							</strong>
						</td>
						<td id='header_title'>
							{' '}
							<strong>Bildtitel</strong>{' '}
						</td>
						<td id='header_kuenstler'>
							{' '}
							<strong>Künstler</strong>{' '}
						</td>
						<td id='header_besitzer'>
							{' '}
							<strong>Besitzer</strong>{' '}
						</td>
						<td id='header_datierung'>
							{' '}
							<strong>Datierung oder Jahr</strong>{' '}
						</td>
						<td id='header_technik'>
							{' '}
							<strong>Technik</strong>{' '}
						</td>
						<td id='header_HxBoR'>
							<strong>
								H x B x T<br />
								in&nbsp;cm&nbsp;(o.R.)
							</strong>
						</td>
						<td id='header_empty'>
							<div>
								<strong>Ausstellungen:</strong>
							</div>{' '}
							<div>
								<strong>Datum, Ort</strong>
							</div>
						</td>
					</tr>
					{data &&
						data.map((d) => (
							<tr
								className='dataEntry'
								style={{
									backgroundColor:
										selectedArtwork === d && 'rgb(187, 242, 201)',
								}}
								onClick={() => setSelectedArtwork(d)}
								key={d.id}
							>
								<td>
									<a href={`/inputMask/artwork/${d.id}`} target='_blank'>
										{loadedIds.indexOf(d.id) + 1}
									</a>
								</td>

								<td>{d.title_description}</td>

								{!read_artist ? (
									<td style={{ color: 'red' }}>{noPermissionText}</td>
								) : (
									<td>
										{pex.read_artist ? (
											<a
												href={'/inputMask/artist/' + d.artistId}
												target='_blank'
											>
												{findArtistFullName(
													d.artistId,
													loadedArtistIds.indexOf(d.artistId) + 1
												)}
											</a>
										) : (
											findArtistFullName(
												d.artistId,
												loadedArtistIds.indexOf(d.artistId) + 1,
												false
											)
										)}
									</td>
								)}
								{!read_owner ? (
									<td style={{ color: 'red' }}>{noPermissionText}</td>
								) : (
									<td>
										{pex.read_owner ? (
											<a href={'/inputMask/owner/' + d.ownerId} target='_blank'>
												{findOwnerFullName(
													d.ownerId,
													loadedOwnerIds.indexOf(d.ownerId) + 1
												)}
											</a>
										) : (
											findOwnerFullName(
												d.ownerId,
												loadedOwnerIds.indexOf(d.ownerId) + 1,
												false
											)
										)}
									</td>
								)}
								<td>{d.dating}</td>
								<td>{d.technik}</td>
								<td>{convertHxBxT(d.HxW_without_Border)}</td>
								<td>{d.exhibitions}</td>
							</tr>
						))}
				</tbody>
			</table>

			{!data.length && <div id='artworksNotFound'> Keine Werke gelistet </div>}
		</div>
	)
}

export default ResultContainer
